"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CheckPartiallyViewport = /** @class */ (function () {
    function CheckPartiallyViewport() {
    }
    CheckPartiallyViewport.checkIfInViewportPartially = function (el) {
        var rect = el.getBoundingClientRect();
        return (rect.top >= -el.offsetHeight && rect.left >= -el.offsetWidth && rect.right <= (window.innerWidth || document.documentElement.clientWidth) + el.offsetWidth && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + el.offsetHeight);
    };
    return CheckPartiallyViewport;
}());
exports.default = CheckPartiallyViewport;
